export default __webpack_public_path__ + "static/media/desertKlein.ed0ed569.jpg";